import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { rupee, fileUrl, productPath } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";

export const ProductCard = ({ p }) => {
  const { has, toggle } = useWishlist();
  const img = fileUrl(p.images?.[0]) || "https://images.unsplash.com/photo-1617134471130-4186de7a137f?w=600&q=80";
  const img2 = fileUrl(p.images?.[1]);
  const wished = has(p.id);
  const href = productPath(p);

  return (
    <div className="group text-center" data-testid={`product-card-${p.id}`}>
      <div className="relative overflow-hidden bg-[hsl(var(--ivory))]">
        <Link to={href} data-testid={`product-link-${p.id}`}>
          <div className="aspect-[3/4] overflow-hidden">
            <img src={img} alt={p.name} loading="lazy" className={`w-full h-full object-cover bc-img-zoom ${img2 ? "group-hover:opacity-0 transition-opacity duration-500" : ""}`} />
            {img2 && <img src={img2} alt="" className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500" />}
          </div>
        </Link>
        {p.discount_pct > 0 && (
          <span className="absolute top-3 left-3 bg-primary text-primary-foreground text-[10px] uppercase tracking-[0.15em] px-2.5 py-1">Sale</span>
        )}
        <button onClick={() => toggle(p.id)} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/85 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300" data-testid={`card-wishlist-${p.id}`} aria-label="Wishlist">
          <Heart className={`w-4 h-4 ${wished ? "fill-primary text-primary" : "text-foreground/70"}`} />
        </button>
        <Link to={href} className="absolute inset-x-3 bottom-3 bg-foreground text-[hsl(var(--ivory))] text-[11px] uppercase tracking-[0.18em] py-3 text-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-testid={`quick-view-${p.id}`}>
          View Product
        </Link>
      </div>
      <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-4">{p.category} · {p.audience}</p>
      <Link to={href}>
        <h3 className="font-display text-xl mt-1 leading-snug hover:text-primary transition-colors line-clamp-1">{p.name}</h3>
      </Link>
      <div className="flex items-center justify-center gap-2 mt-1 text-sm">
        <span className="text-foreground">{rupee(p.min_price)}</span>
        {p.mrp > p.min_price && <span className="text-muted-foreground line-through text-xs">{rupee(p.mrp)}</span>}
      </div>
    </div>
  );
};
